import { defineComponent } from "vue";
import Index from "../Chat/index/index.mjs";
import MasterApplyControl from "../RoomFooter/ApplyControl/MasterApplyControl/index.mjs";
import index from "../ManageMember/index.mjs";
import popup from "../common/base/PopUpH5.vue.mjs";
import useSideBar from "./useSideBarHooks.mjs";
import ChatEditor from "../Chat/ChatEditor/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "indexH5",
  setup(__props) {
    const { title, sidebarName, showSideBar } = useSideBar();
    return { __sfc: true, title, sidebarName, showSideBar, Chat: Index, MasterApply: MasterApplyControl, ManageMember: index, popup, ChatEditor };
  }
});
export {
  _sfc_main as default
};
